<template>
  <Label
    data-slot="label"
    v-bind="delegatedProps"
    :class="
      cn(
        'tw:flex tw:items-center tw:gap-2 tw:type-label tw:select-none tw:group-data-[disabled=true]:pointer-events-none tw:group-data-[disabled=true]:opacity-50 tw:peer-disabled:cursor-not-allowed tw:peer-disabled:opacity-50',
        props.class,
      )
    "
  >
    <slot />
  </Label>
</template>

<script setup>
defineOptions({ name: 'UiLabel' });
import { reactiveOmit } from '@vueuse/core';
import { cn } from '@/shared/utilities/classes';
import { Label } from 'reka-ui';

const props = defineProps({
  for: { default: undefined, type: String, required: false },
  asChild: { default: undefined, type: Boolean, required: false },
  as: { default: undefined, type: null, required: false },
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');
</script>
